// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"100":"91333ff3","930":"eb0d2a58"}[chunkId] + ".css";
};